import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material/styles';
import { ErrorBoundary } from 'react-error-boundary';

import ErrorFallbackComponent from './components/errorFallbackComponent/ErrorFallbackComponent';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store()}>
      <StyledEngineProvider injectFirst>
        <ErrorBoundary
          FallbackComponent={ErrorFallbackComponent}
          onReset={() => window.location.replace('/')}
        >
          <App />
        </ErrorBoundary>
      </StyledEngineProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
